import { render, staticRenderFns } from "./Mob-app.vue?vue&type=template&id=141b1bc0&scoped=true&"
import script from "./Mob-app.vue?vue&type=script&lang=js&"
export * from "./Mob-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141b1bc0",
  null
  
)

export default component.exports